<template>
    <ul class="list-inline m-0 p-0 flex items-center justify-center gap-[5px] w-max mx-auto ">
        <li>
            <a @click="contractorAgreementClicked" class="text-[12px] font-poppins cursor-pointer underline text-[#2459A8]">Terms
                and Conditions</a>
        </li>
        <li class="mt-[5px] text-[12px] font-poppins text-[#F5B134]"> - </li>
        <li>
            <a @click="privacyPolicyClicked" class="text-[12px] font-poppins cursor-pointer underline text-[#2459A8]">Privacy
                Policy</a>
        </li>
    </ul>
</template>
<script>
export default {

    components: {

    },
    data() {
        return {

        };
    },


    computed: {

    },



    mounted() {

    },

    beforeUnmount() {

    },

    methods: {

        privacyPolicyClicked() {
            const url = this.$router.resolve({ name: "privacyPolicy" }).href;
            window.open(url, "_blank");
        },

        contractorAgreementClicked() {
            const url = this.$router.resolve({ name: "termsAndConditions" }).href;
            window.open(url, "_blank");
        }

    },

};
</script>
